module.exports = __webpack_public_path__ + "static/media/clouds-sistemas.a927d85f.webp";